import { TokenResponseSchema as k } from "@hprofits/api/auth";
import { createInMemoryStorage as _ } from "../../storage/in-memory.js";
import { createApiClient as u } from "../client.js";
import { createAuthState as A } from "./auth-state.js";
const y = "hp", R = (e, r) => r ? () => ({ ...typeof r == "function" ? r() : r, ...e.getAuthHeader() }) : () => e.getAuthHeader(), p = (e) => {
  if (!e.refresh_token)
    throw new Error("Server response missing refresh_token");
  return {
    accessToken: e.access_token,
    refreshToken: e.refresh_token
  };
}, d = 3600, w = (e, r, s, c) => {
  const o = { pending: null }, n = async () => {
    if (c) {
      const a = await c();
      return r.setTokens(a), k.parse({
        access_token: a.accessToken,
        refresh_token: a.refreshToken,
        token_type: "Bearer",
        expires_in: d
      });
    }
    let t;
    if (s) {
      const a = await s();
      t = k.parse({
        access_token: a.access_token,
        refresh_token: a.refresh_token,
        token_type: a.token_type ?? "Bearer",
        expires_in: a.expires_in ?? d
      });
    } else {
      const a = r.getRefreshToken();
      if (!a)
        throw new Error("Cannot refresh token: no refresh token is set");
      t = await e.token.refresh({
        body: { refresh_token: a }
      });
    }
    return r.setTokens(p(t)), t;
  };
  return { refresh: async () => {
    if (o.pending)
      return o.pending;
    const t = n();
    return o.pending = t, t.finally(() => {
      o.pending === t && (o.pending = null);
    });
  } };
}, g = 401, m = 403, E = (e, r, s) => (e.status === g || e.status === m) && r && s.isAuthenticated(), T = (e, r) => {
  Object.entries(r).forEach(([s, c]) => e.set(s, c));
}, H = async (e, r, s, c) => {
  const o = c.getAuthHeader();
  if (r instanceof Request) {
    const h = new Headers(r.headers);
    T(h, o);
    const t = s?.signal ?? r.signal;
    return e(new Request(r, { headers: h, ...t ? { signal: t } : {} }));
  }
  const n = new Headers(s?.headers);
  return T(n, o), e(r, { ...s, headers: n });
}, x = (e, r, s, c) => async (o, n) => {
  const h = o instanceof Request && c && r.isAuthenticated() ? o.clone() : o, t = await e(o, n);
  if (!E(t, c, r))
    return t;
  try {
    return await s.refresh(), H(e, h, n, r);
  } catch {
    return t;
  }
}, I = (e) => {
  const r = e.autoRefreshOnUnauthorized ?? !0, s = e.fetch ?? fetch, c = e.storage ?? _(), o = e.keyPrefix ?? y, n = A({ storage: c, keyPrefix: o }), h = R(n, e.headers), t = u({
    baseURL: e.baseURL,
    headers: h,
    fetch: s
  }), a = w(t, n, e.refreshTokens, e.externalRefresh), l = x(s, n, a, r);
  return {
    ...u({
      baseURL: e.baseURL,
      headers: h,
      fetch: l
    }),
    async login(i) {
      const f = await t.token.create({ body: i });
      return n.setTokens(p(f)), f;
    },
    refreshToken: () => a.refresh(),
    async logout() {
      const i = await t.session.remove({});
      return n.clearTokens(), i;
    },
    isAuthenticated: () => n.isAuthenticated(),
    getToken: () => n.getAccessToken(),
    setTokens: (i) => n.setTokens(i)
  };
};
export {
  I as createStatefulApiClient
};
//# sourceMappingURL=client.js.map
